import { render } from "./ErrorModal.html?vue&type=template&id=030d6cf4&scoped=true"
import script from "./ErrorModal.js?vue&type=script&lang=js"
export * from "./ErrorModal.js?vue&type=script&lang=js"

import "./ErrorModal.css?vue&type=style&index=0&id=030d6cf4&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/Shiptech MyPlusRewards/mpr-web-admin-portal/src/MPR.MyPlusRewardsAdminPortal.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-030d6cf4"]])

export default __exports__